export default __webpack_public_path__ + "static/media/GregorySantini.7a99eb32.png";